import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from '../../hooks/useTranslation.jsx';

/**
 * Token transparency: what an agent answer or a thread of agent work cost.
 * `usage` = { calls, input, output, cacheRead, cacheCreation, costUsd, steps? }.
 * Title shows the per-step breakdown when there is one.
 */
const Line = styled.span`
  font-size: 10.5px;
  color: rgba(255, 255, 255, 0.42);
  white-space: nowrap;
`;

const fmt = (n, lang) => new Intl.NumberFormat(lang === 'en' ? 'en-GB' : lang === 'sv' ? 'sv-SE' : 'fi-FI').format(n || 0);

export function usageText(usage, t, lang) {
  if (!usage) return '';
  const tokens = (usage.input || 0) + (usage.output || 0) + (usage.cacheRead || 0) + (usage.cacheCreation || 0);
  const parts = [];
  if (usage.calls > 1) parts.push(t('chatAgent.usage.calls', { n: usage.calls }));
  parts.push(t('chatAgent.usage.tokens', { n: fmt(tokens, lang) }));
  if (usage.costUsd != null) parts.push(t('chatAgent.usage.cost', { usd: (Math.round(usage.costUsd * 1000) / 1000).toFixed(3) }));
  else parts.push(t('chatAgent.usage.costUnknown'));
  return parts.join(' · ');
}

export default function UsageLine({ usage, prefix = '' }) {
  const { t, language } = useTranslation();
  if (!usage) return null;
  const title = usage.steps?.length
    ? usage.steps.map((s) => `${s.step}: ${fmt((s.input || 0) + (s.output || 0), language)} tok${s.costUsd != null ? ` · $${s.costUsd.toFixed(3)}` : ''}`).join('\n')
    : usage.model ? `${usage.model} · in ${fmt(usage.input, language)} / out ${fmt(usage.output, language)}` : undefined;
  return <Line title={title}>{prefix}{usageText(usage, t, language)}</Line>;
}
